export default __webpack_public_path__ + "static/media/logo-icicles.ba7b8ef0.svg";